import { render } from "./Control.vue?vue&type=template&id=9f9d1584&scoped=true"
import script from "./Control.vue?vue&type=script&lang=js"
export * from "./Control.vue?vue&type=script&lang=js"

import "./Control.vue?vue&type=style&index=0&id=9f9d1584&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9f9d1584"

export default script